// The apps' options-sheet icon set (iOS Assets.xcassets/OptionsSheetIcons, Android
// res/drawable/options_ic_*), copied as-is so a web Options menu shows the same glyph
// the apps do for the same action. Single-colour SVGs, drawn as a CSS mask so a tile
// can tint them white, or blue for a PRO+ tool, as the apps do.
import addCircle from '../../../images/options_icons/options_ic_add_circle.svg';
import code from '../../../images/options_icons/options_ic_code.svg';
import download from '../../../images/options_icons/options_ic_download.svg';
import flag from '../../../images/options_icons/options_ic_flag.svg';
import location from '../../../images/options_icons/options_ic_location.svg';
import mountain from '../../../images/options_icons/options_ic_mountain.svg';
import pencil from '../../../images/options_icons/options_ic_pencil.svg';
import pin from '../../../images/options_icons/options_ic_pin.svg';
import print from '../../../images/options_icons/options_ic_print.svg';
import ruler from '../../../images/options_icons/options_ic_ruler.svg';
import warning from '../../../images/options_icons/options_ic_warning.svg';

export const OPTIONS_ICONS = {
  add_circle: addCircle,
  code,
  download,
  flag,
  location,
  mountain,
  pencil,
  pin,
  print,
  ruler,
  warning,
} as const;

export type OptionsIcon = keyof typeof OPTIONS_ICONS;

/**
 * The CSS mask value for [icon]. Quoted: Vite inlines small SVGs as data: URIs, whose quotes
 * and spaces make an unquoted url() invalid — and an invalid custom property is dropped silently.
 */
export function optionsIconMask(icon: string): string {
  const url = (OPTIONS_ICONS as Record<string, string>)[icon];
  return typeof url === 'string' && url ? cssUrl(url) : 'none';
}

/** A CSS url() for [url], quoted and escaped so a data: URI's quotes and spaces can't break it. */
export function cssUrl(url: string): string {
  return `url(${JSON.stringify(url)})`;
}
